import React from 'react';
import {logout} from "../services/auth-services";
import { useHistory } from "react-router-dom";

const LogoutPage = () => {

    let history = useHistory();
    logout();
    history.push('/home');

    return (
        <div>
            <h6>Logging out..</h6>
        </div>
    );
}

export default LogoutPage;